module.exports = __webpack_public_path__ + "static/media/0002.64bc289e.jpg";